import { render, staticRenderFns } from "./UsStep4.vue?vue&type=template&id=435cf656&scoped=true&lang=tr"
import script from "./UsStep4.vue?vue&type=script&lang=js"
export * from "./UsStep4.vue?vue&type=script&lang=js"
import style0 from "./UsStep4.vue?vue&type=style&index=0&id=435cf656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435cf656",
  null
  
)

export default component.exports